// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-alert {\n  position: fixed !important;\n  left: 50%;\n  top: 20%;\n  transform: translate(-50%, -50%);\n  margin: 0 auto;\n}\n.v-input {\n  padding-top: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
